import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
import App from './App.vue'
import router from './router'
Vue.use(ElementUI);

// token
Vue.prototype.$token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJteV91c2VyIiwiaWF0IjoxNzEzMTQzODk0LCJleHAiOjE3MTMxNDUzNjU3ODgsImlkIjoiMTY1NDY1MjMxNjU0NSIsIm5pY2tOYW1lIjoi5pSv55CzIiwicm9sZSI6InN1cGVyQWRtaW4iLCJ0aW1lIjoxNzEzMTQzODk0NTYwfQ.opf6o1VN9mqY4tDS-RQtBPfbYeRFhysvL8PgohMvsjs';
// 挂载一个自定义属性$http
Vue.config.productionTip = false
Vue.prototype.$http = axios
// 全局配置axios请求根路径(axios.默认配置.请求根路径)
// axios.defaults.baseURL = 'http://192.168.2.249:8091'
// axios.defaults.baseURL = 'http://192.168.2.83:8084/pro-api'
// axios.defaults.baseURL = 'http://192.168.2.195:8085/pro-api'
// axios.defaults.baseURL = process.env.VUE_APP_BASE_API
axios.defaults.baseURL = 'https://nationaldebt.youalltech.com/pro-api'
new Vue({
    router,
    render: h => h(App)
  }).$mount('#app')
